import { UserDto } from '@act/shared/data-transfer-objects';
import {
  FlexContainer,
  IconMessage,
  ReemaThemeV2,
  SingleCardPage,
} from '@act/storybook';
import { CssBaseline, GlobalStyles } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { MemberPage } from 'react-components/member-page/MemberPage';
import { useSearchParams } from 'react-router-dom';
import { selectMember } from 'redux/slices/selectedMemberSlice';
import { avonPatientRequests } from 'redux/requests/avon-patient.requests';
import { useAppDispatch } from 'redux/store-hooks';
import { useApiCall } from 'redux/utils/api-hook';

export const AvonPatientEmbed = () => {
  const [params] = useSearchParams();
  const patientId = params.get('id');

  const dispatch = useAppDispatch();
  const [response, isLoading, makeApiCall] = useApiCall(
    avonPatientRequests.getMemberIdFromAvonPatientId
  );

  useEffect(() => {
    void makeApiCall({ params: { avonPatientId: patientId } });
  }, []);

  const [member, setMember] = useState<UserDto>();

  useEffect(() => {
    if (response) {
      dispatch(selectMember(response.member.id));
      setMember(response.member);
    }
  }, [response]);

  if (isLoading) {
    return (
      <ThemeProvider theme={ReemaThemeV2.LIGHT_MODE}>
        <CssBaseline />
        <GlobalStyles
          styles={{
            '*': {
              fontFamily: "'Inclusive Sans', 'Lato', 'sans-serif' !important",
            },
          }}
        />
        <SingleCardPage showBorderTop={false}>
          <FlexContainer
            direction="column"
            alignItems="center"
            justifyContent="center"
            gap={3}
            sx={{ paddingBottom: 3 }}
          >
            {isLoading && (
              <IconMessage
                message="Finding member page"
                iconName="MagnifyingGlass"
                iconColor="primary"
              />
            )}
            {!isLoading && !member && (
              <IconMessage
                message="No member found"
                subMessage={`Could not find the member based on the Avon patient ID "${patientId}"`}
                iconName="UserCircleMinus"
                iconColor="primary"
              />
            )}
          </FlexContainer>
        </SingleCardPage>
      </ThemeProvider>
    );
  } else {
    return <MemberPage />;
  }
};
